export default "__VITE_ASSET__CvI$6qBk__"